<template>
  <Transition name="bl-sheet-animation">
    <div v-if="active" :class="sheetClasses">
      <div class="bl-sheet__overlay" @click="close()"></div>
      <div ref="sheet" class="bl-sheet__box" @scroll="scrollHandle">
        <div ref="sheetNavBar" v-padDown="onPan" class="bl-sheet__nav-bar">
          <span v-if="autoHeight" class="bl-sheet__nav-bar-handler"></span>
          <div class="bl-sheet__nav-bar-inner flex items-center">
            <span class="bl-sheet__icon" @click="close()">
              <!-- @slot Slot to provide/custom an icon left nav bar -->
              <slot name="iconLeftNavBar">
                <IcoUiCross color="active-darker" />
              </slot>
            </span>
            <slot name="title">
              <bl-text-av variation="subheading-18">{{ title }}</bl-text-av>
            </slot>
            <template v-if="textAction">
              <span class="bl-sheet__text-action" style="bottom: 25px">
                <bl-button-av size="small" variation="link" @click.native="clickAction">
                  {{ textAction }}
                </bl-button-av>
              </span>
            </template>
          </div>
        </div>
        <div class="bl-sheet__content">
          <!-- @slot Slot to provide a content -->
          <slot name="content"></slot>
        </div>
        <div v-if="$slots.footer" class="bl-sheet__footer">
          <!-- @slot Slot to provide a footer -->
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import {padDown} from '@bukalapak/bazaar-mweb-next/src/directives/padDownDirective';
import {BlButtonAv} from '@bukalapak/bazaar-mweb-latest';
import {IcoUiCross} from '@bukalapak/bazaar-visual-next';

export default {
  name: 'BlSheetMv',
  status: 'ready',
  release: '1.9.0',
  directives: {
    padDown,
  },
  components: {
    BlButtonAv,
    IcoUiCross,
  },
  props: {
    /**
     * Title Sheet
     */
    title: {
      type: String,
      default: '',
    },
    /**
     * Text Action
     */
    textAction: {
      type: String,
      default: '',
    },
    /**
     * Auto height container sheet
     * `true, false`
     */
    autoHeight: {
      type: Boolean,
      default: false,
    },
    /**
     * Active
     * `true, false`
     */
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      maxOffset: 100,
    };
  },
  computed: {
    sheetClasses() {
      const baseClass = 'bl-sheet';
      let classes = [baseClass];

      this.active ? classes.push(`is-active`) : '';
      this.autoHeight ? classes.push(`is-auto-height`) : '';

      return classes;
    },
  },
  watch: {
    active(value) {
      this.bodyHandle(value);
    },
  },
  mounted() {
    window.onpopstate = this.leaving;
  },
  beforeDestroy() {
    return this.leaving();
  },
  methods: {
    onPan /* istanbul ignore next */(e) {
      if (this.$refs.sheet) {
        if (e.deltaY > this.maxOffset) {
          this.close();
        }
      }
    },
    scrollHandle(event) {
      const header = this.$refs.sheetNavBar;
      if (this.active) {
        if (event.target.scrollTop > 20) {
          header.classList.add('has-box-shadow');
        } else {
          header.classList.remove('has-box-shadow');
        }
      }
    },
    bodyHandle(value) {
      value ? (document.body.style.overflow = 'hidden') : (document.body.style.overflow = 'auto');
    },
    leaving() {
      document.body.style.overflow = 'auto';
    },
    /**
     * Event click after user clicked close action.
     *
     * @type function
     * @event close
     */
    close() {
      this.$emit('close');
      this.$emit('update:active', false);
    },
    /**
     * Event click after user clicked text action.
     *
     * @type function
     * @event clickAction
     */
    clickAction() {
      this.$emit('clickAction');
    },
  },
};
</script>

<style lang="scss" scoped>
.bl-sheet__nav-bar {
  padding: 32px 16px 16px 16px;
  .bl-sheet__nav-bar-inner {
    display: flex;
    align-items: center;
  }
  .bl-sheet__icon {
    position: inherit;
  }
}
</style>
